import { DietDTO, DietsFormFields } from 'types';

import dayjs from 'dayjs';

export const parseDietDTOIntoDietsFormFields = (dietData: DietDTO): DietsFormFields => {
    const { name, meals } = dietData;

    // Convert current meal prices from the most recent entry to flat form fields
    const formData: DietsFormFields = { name } as DietsFormFields;

    const lenghtOfMeals = meals?.length;
    // Get the most recent meal price entry (first in array, assuming sorted by date desc)
    const currentMealPrices = meals?.[lenghtOfMeals - 1]?.mealPrices || [];
    const mostRecentMeal = meals?.[lenghtOfMeals - 1];

    if (mostRecentMeal?.dateFrom) {
        const dateFrom = dayjs(mostRecentMeal.dateFrom);
        const now = dayjs();
        formData.dateFrom = now.isAfter(dateFrom) ? now : dateFrom;
    } else {
        formData.dateFrom = dayjs();
    }

    currentMealPrices.forEach((mealPrice) => {
        formData[`mealPrice_${mealPrice.mealTypeId}`] = mealPrice.price;
    });

    formData.dateFrom = dayjs(mostRecentMeal?.dateFrom, 'YYYY-MM-DD').add(1, 'days');

    return formData;
};
